import actions from './actions';
import mutations from './mutations';

const orders = {
    namespaced: true,
    state: {
        autocompleteAdresses: [],
        orderHistories: [],
        clientStatusesHistory: [],
        orderDrivers: [],
        filteredOrderDrivers: [],
        brandDetails: null,
        polyline: [],
        lines: [],
        groupOrdersCoords: [],
        allOrders: [],
        coordinates: [],
        isShowHistory: false,
        addressCoords: {
            latitude: null,
            longitude: null
        },
        activeOrderAddresses: [{}],
        driverCallSign: null,
        activeDriver: null,
    },
    mutations,
    actions
};

export default orders;
